import AuthService from "../services/Auth.service";

export class checkPermission{
    static hasPermission(permissions,check_all = true){
        let permissionArray = AuthService.getPermissions();
        if (permissionArray.length > 0) {
            for (let i = 0; i < permissions.length; i++) {
              if (check_all) {
                if (!permissionArray.some((item) => item === permissions[i])) {
                  return false;
                }
              } else {
                if (permissionArray.some((item) => item === permissions[i])) {
                  return true;
                }
              }
            }
            return check_all;
          }
          return false;
    }
}